<template>
  <!-- avatar start -->
  <div :class="['avatar-screen',
      {'avatar-screen--1':  $route.params.level==1 || $route.params.level==2 },
      {'avatar-screen--3':  $route.params.level==3},
      {'avatar-screen--4':  $route.params.level==4},
  ]">
    <div class="avatar">
      <label for="file-input-modal" v-if="$route.params.level==1 || $route.params.level==2" :title="$t('profile.changeAvatar')">
        <img v-if="user.avatar" :src="user.avatar" alt="avatar" class="rounded-circle avatar-img" />
        <!--<img v-if="localAvatar" :src="localAvatar" alt="avatar" class="rounded-circle avatar-img" />-->
        <img v-else src="../../../../assets/avatars/Avatar_girl.svg" :style="{backgroundColor: 'white'}" alt="avatar" class="rounded-circle avatar-img" />
        <i class="fa fa-camera" aria-hidden="true"></i>
      </label>
      <label for="file-input-modal" v-if="$route.params.level==3" :title="$t('profile.changeAvatar')">
        <!--<img v-if="localAvatar" :src="localAvatar" alt="avatar" class="rounded-circle avatar-img" />-->
        <img v-if="user.avatar" :src="user.avatar" alt="avatar" class="rounded-circle avatar-img" />
        <img v-else src="@/assets/icons/menu/new_menu_icons/iconosMiddleSchool/avatarMLms_01.svg" alt="avatar" class="rounded-circle avatar-img" />
        <i class="fa fa-camera" aria-hidden="true"></i>
      </label>
      <label for="file-input-modal" v-if="$route.params.level==4" :title="$t('profile.changeAvatar')">
        <img v-if="user.avatar" :src="user.avatar" alt="avatar" class="rounded-circle avatar-img" />
        <img v-else src="@/assets/icons/menu/new_menu_icons/iconosHighSchool/Foto.svg" alt="avatar" class="rounded-circle avatar-img" />
        <i class="fa fa-camera" aria-hidden="true"></i>
      </label>
      <label for="file-input-modal" v-if="!$route.params.level" :title="$t('profile.changeAvatar')">
        <img v-if="user.avatar" :src="user.avatar" alt="avatar" class="rounded-circle avatar-img" />
        <img v-else src="@/assets/avatars/user_generic.jpg" alt="avatar" class="rounded-circle avatar-img" />
        <i class="fa fa-camera" aria-hidden="true"></i>
      </label>
      <input id="file-input-modal" @click="toggleAvatar" />
    </div>
    <div class="wrap">
      <div class="wrap__container">
        <div>
          <h1 class="text-capitalize name">{{ fullName }}</h1>
        <router-link v-if="roles.includes('student')" :to="{ name: 'studentProfile' }" class="view-perfile">{{
          $t('sidebar.viewProfile')
        }}</router-link>
        <router-link v-if="roles.includes('tutor')" :to="{ name: 'tutorProfile' }" class="view-perfile">{{
          $t('sidebar.viewProfile')
        }}</router-link>
        <hr />
        </div>
      </div>
    </div>

    <!-- Change avatar modal -->
    <tpm-modal :showhide="showAvatar">
      <div class="modal-header">
        <div class="modal-header-content">
          <h1>{{ $t('avatar.title') }}</h1>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleAvatar">
            <img src="@/assets/icons/exit1.png" class alt="Close" />
          </button>
        </div>

        <!-- Old header -->
        <!-- <h1>{{ $t('avatar.title') }}</h1>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleAvatar">
          <img src="@/assets/icons/exit1.png" class alt="Close" />
        </button> -->
      </div>
      <div id="avatar-modal" v-focus class="modal-body" tabindex="0" @keyup.esc="toggleAvatar">
        <Carousel
          class="avatars"
          :navigation-enabled="true"
          pagination-active-color="#28a745"
          :per-page="4"
          pagination-color="#ffc107"
          navigation-prev-label
          navigation-next-label
          :scroll-per-page="true"
        >
          <Slide v-for="(tutor, index) in avatars" :key="index">
            <input
              :id="'tutor' + index"
              type="radio"
              name="avatar"
              :value="tutor"
              class="avatar-image"
              @change="setAvatar"
            />
            <label :for="'tutor' + index">
              <img :src="tutor" :alt="'tutor' + index" />
              <span>
                <img src="@/assets/img/checkmark.png" alt />
              </span>
            </label>
          </Slide>
        </Carousel>

        <div class="row">
          <div class="col-md-12">
            <div class="upload">
              <div class="avatar">
                <label for="file-input">
                  <img
                    v-if="user.avatar"
                    id="user-avatar-upload"
                    :src="user.avatar"
                    alt="avatar"
                    class="rounded-circle avatar-img"
                    :title="$t('profile.changeAvatar')"
                  />
                  <img
                    v-else
                    id="user-avatar-upload"
                    src="@/assets/avatars/avatarYellow.png"
                    alt="avatar"
                    class="rounded-circle avatar-img"
                    :title="$t('profile.changeAvatar')"
                  />
                  <i class="fa fa-camera" aria-hidden="false"></i>
                  <span>
                    <img src="@/assets/img/checkmark.png" alt />
                  </span>
                </label>
                <input id="file-input" type="file" @change="updateAvatar" />
                <p class="mt-3 avatar-paragraph">{{ $t('avatar.upload') }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12">
            <div class="upload-buttons-container">
              <div class="cancel-button">
                <button class="btn btn-danger" @click="toggleAvatar">{{ $t('singup.cancel') }}</button>
              </div>
              <div class="save-button">
                <button class="btn btn-success" @click="saveAvatar">{{ $t('avatar.save') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </tpm-modal>
  </div>
  <!-- #avatar end -->
</template>
<script>
import { mapGetters } from 'vuex';
import Avatars from './avatars';
import { Carousel, Slide } from 'vue-carousel';
import avatars from './avatars';

export default {
  name: 'Avatar',
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      avatar: '',
      avatars: Avatars.student,
      showAvatar: false,
      prevModalStyles: null,
      wsSaveAvatar: '',
       level:0,
       localAvatar:null,
    };
  },
 /*async  created(){
    this.checkChangeAvatar();
    let self= this;
    fetch(require("../../../../assets/avatars/Avatar_girl.svg"))
    .then(function(response) {
      return response.blob()
    })
    .then(async function(blob) {
      // here the image is a blob
      const result = await self.blobToBase64(blob);
      self.avatars[0]=result;
    });
  },*/
  computed: {
    ...mapGetters({
      user: 'auth/authenticatedUser',
      roles: 'auth/roles',
    }),
    fullName() {
      return this.user.firstname + ' ' + this.user.lastname;
    },
  },
  methods: {
    toggleAvatar() {
      var payload = null;
      if (this.showAvatar) {
        payload = this.prevModalStyles;
      } else {
        this.prevModalStyles = this.$store.state.style.modal;
        payload = {
          width: '1000',
          prefixWidth: 'px',
          height: '500',
          prefixHeight: 'px',
        };
      }
      this.$store.commit('SET_STYLE_MODAL', payload);
      this.showAvatar = !this.showAvatar;
    },
    /** Oculta y muestra el sidebar */
    toggleSidebar() {
      if (this.$store.state.sidebar === false) {
        this.$store.commit('showSidebar', true);
      } else {
        this.$store.commit('showSidebar', false);
      }
    },
    setAvatar(e) {
      this.avatar = e.target.value;
      //localStorage.setItem('avatar',e.target.value);
      //this.checkChangeAvatar();
      document.getElementById('user-avatar-upload').classList.remove('selected');
    },
    updateAvatar(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = e => {
        vm.avatar = e.target.result;
        document.getElementById('user-avatar-upload').src = e.target.result;
        document.getElementById('user-avatar-upload').classList.add('selected');
        Array.from(document.getElementsByClassName('avatar-image')).map(avatar => {
          avatar.checked = false;
        });
      };
      reader.readAsDataURL(file);
    },
    saveAvatar() {
      var self = this;

      this.$httpMain
        .post(`update-avatar`, {
          data: this.avatar,
          token: this.$store.state.cookie,
        })
        .then(function () {
          // Se inserta el valor del nuevo avatar en store
          self.$store.dispatch('changeAvatarOfUserAuthenticated', self.avatar);
          // Refresh data
          self.user.avatar = self.avatar;
          // Se resetea el valor de avatar
          self.avatar = '';

          // Validate some generated error!
          if (self.$toasted) {
            self.$toasted.success(self.$t('sidebar.savedSatis'), {
              position: 'bottom-left',
              duration: 1500,
              icon: {
                name: 'check-circle',
              },
            });
          }

          self.showAvatar = false;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    blobToBase64(blob){
      const reader = new FileReader();
       reader.readAsDataURL(blob);
       return new Promise(resolve=>{
          reader.onloadend = () => {
            resolve(reader.result);
          };
       });
    },
    checkChangeAvatar(){
      if (localStorage.getItem('avatar')!==undefined){
        this.localAvatar=localStorage.getItem('avatar');
        console.log(this.localAvatar);
      }
    }
  },
  watch:{
    $route (to, from){
        this.level= to.params.level;
    },
    localAvatar(val1, val2){
      console.log(val1); 
        this.checkChangeAvatar();
    }
  } 
};
</script>

<style lang="scss" scoped>
$color-text-blue: #3960A5;
$color-text-yellow: #F2AC31;

a:link {
  text-decoration: none;
  display: block;
}
hr {
  margin-right: 20px;
  margin-left: 20px;
  border-top: 2px solid green;
}
.rounded-circle{
  background-color: white;
}
/* --------------------------------- */
/* 2. Custom Utility Classes
 ----------------------------------- */
.avatar-screen {
  user-select: none;
  .avatar {
    position: relative;
    cursor: pointer;
    .avatar-img {
      display: block;
      margin: 0 auto;
      margin-top: 30px;
      height: 115px;
      width: 125px;
      &:hover .fa.fa-camera{
        opacity: 1;
      }
    }
    i {
      opacity: 0;
      position: absolute;
      bottom: 10%;
      left: calc(50% - 0.5rem);
    }
    &>input {
      display: none;
    }
    label {
      cursor: pointer;
      display: block;
    }
  }
  .wrap__container {
    margin: 0 1rem;
  }
  .name {
    font-family: "Futura", Helvetica, Arial;
    margin: 15px;
    font-size: 1rem;
    background: white;
    border-radius: 25px;
    padding: 0 1.5rem 5px;
    text-align: center;
  }
  .view-perfile {
    color: white;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    font-family: 'comfortaabold';
    padding-top: 0.5rem;
  }
  hr {
   border-top: 2px solid white;
  margin: unset;
  }
}
.avatar-screen--1 {
  .wrap {
    position: relative;
    &__container {
      margin: unset;
      position: relative;
      div {
     width: 100%;
     padding: 0 2rem;
     text-align: center;
         .name {
            margin-bottom: 0;
            font-size: 1rem;
            margin: 1rem 0.5rem 0;
            font-family: "FuturaBold", Helvetica, Arial;
            color: $color-text-blue;
          }
          .view-perfile {
            color: white;
            font-size: 13px;
            font-weight: 600;
            text-align: center;
            font-family: 'comfortaabold';
            padding-top: 0.5rem;
          }
          hr {
          border-top: 2px solid white;
          margin: unset;
          padding-bottom: 1rem;
          }
      }
    }
  }
}
.avatar-screen--3 {
  .wrap{
    &__container{
      margin-bottom: 1rem;
      .name{
        color: $color-text-yellow;
        margin: 1rem 0 1rem;
        font-family: "FuturaBold", Helvetica, Arial;
      }
    }
  }
}
.avatar-screen--4 {
  .wrap{
    &__container{
      margin-bottom: 1rem;
      .name{
        color: white;
        background-color: unset;
        margin: 1rem 0 0;
        font-family: "FuturaBold", Helvetica, Arial;
      }
        hr {
          border-top: unset;
          margin: unset;
          }
    }
  }
}

/*.avatar-img:hover + .fa.fa-camera {
  opacity: 1;
}
.avatar > input {
  display: none;
}
.avatar label {
  cursor: pointer;
  display: block;
}*/

.btn-close {
  position: absolute;
  top: 4px;
  right: 16px;
  color: #fff;
  font-size: 25px;
  cursor: pointer;
}
/* --------------------------------- */
/* 15. Custom Styles
 ----------------------------------- */

/*customizing boostrap*/
.modal-header {
  border: none;
  background-color: #ffc107;
  // h1 {
  //   margin: 0;
  //   color: #fff;
  //   font-size: 30px;
  // }
  // .close {
  //   position: absolute;
  //   top: 30px;
  //   right: 30px;
  //   opacity: 1;
  //   img {
  //     width: 30px;
  //   }
  //   &:focus {
  //     outline: none;
  //   }
  // }
}
.modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .avatars {
    width: 100%;
    input {
      display: none;
    }
    label {
      position: relative;
      cursor: pointer;
      border-radius: 100%;
      &:hover {
        box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.7);
      }
      span {
        display: none;
      }
    }
    input:checked + label span {
      position: absolute;
      display: block;
      bottom: 0;
      right: 0;
      pointer-events: none;
      img {
        width: 50px;
        height: 50px;
      }
    }
  }
  img {
    width: 150px;
    height: 150px;
  }
  .upload {
    margin-top: 30px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    div {
      flex-grow: 1;
      flex-basis: 0;
      text-align: center;
    }
    img {
      margin: 0 auto;
    }
    p {
      width: 250px;
      margin: auto;
      font-size: 18px;
      cursor: auto;
    }
    button {
      width: 200px;
    }
    label {
      position: relative;
      width: 150px;
      margin: auto;
    }
    span {
      display: none;
      position: absolute;
      bottom: 0;
      right: 0;
      pointer-events: none;
      img {
        width: 50px;
        height: 50px;
      }
    }
    .selected ~ span {
      display: block;
    }
  }
}
</style>
<style lang="scss">
#avatar-modal {
  .VueCarousel-inner {
    padding: 10px 0 !important;
  }
  .VueCarousel-slide {
    text-align: center;
    label {
      margin: auto;
    }
  }
  .VueCarousel-navigation--disabled {
    color: #ff6d00;
  }
  .VueCarousel-dot {
    margin-top: 0 !important;
  }
  .VueCarousel-navigation-button.VueCarousel-navigation-prev {
    display: block;
    background-image: url('~@/assets/img/navigation-left.png');
    background-repeat: no-repeat;
    height: 64px;
    width: 26px;
    left: 20px;
    top: 90px;
  }
  .VueCarousel-navigation-button.VueCarousel-navigation-next {
    display: block;
    background-image: url('~@/assets/img/navigation-right.png');
    background-repeat: no-repeat;
    height: 64px;
    width: 26px;
    right: 20px;
    top: 90px;
  }
}
hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.upload-buttons-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.upload-buttons-container > .cancel-button > button,
.upload-buttons-container > .save-button > button {
  min-width: 180px;
}

@media (max-width: 400px) {
  .upload-buttons-container {
    flex-direction: column;
  }

  .upload-buttons-container > .cancel-button > button {
    margin-bottom: 10px;
  }

  .upload-buttons-container > .cancel-button > button,
  .upload-buttons-container > .save-button > button {
    width: 100%;
  }
}

.modal-header-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.modal-header-content > h1 {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 30px;
}

.modal-header-content > .close {
  position: absolute;
  top: 20px;
  right: 30px;
  opacity: 1;
}

.modal-header-content > .close > img {
  max-width: 30px;
}

@media (max-width: 380px) {
  .modal-header-content > h1 {
    font-size: 25px;
  }

  .modal-header-content > .close > img {
    max-width: 25px;
  }

  .modal-header-content > .close {
    top: 17px;
  }

  .avatar-paragraph {
    width: 100% !important;
  }
}

@media (max-width: 310px) {
  .modal-header-content > h1 {
    font-size: 20px;
  }

  .modal-header-content > .close > img {
    max-width: 20px;
  }
}

.modal-content {
  overflow-y: scroll;
  min-height: 650px !important;
  position: absolute !important;
  top: 10%;
}

@media (max-width: 1026px) {
  .modal-content {
    min-height: 400px !important;
    top: 0px;
  }
}
</style>
